import { useInventoryAssetForm } from "../../Hooks/Features/InventoryDashboard/useInventoryAssetForm";
import { renderField } from "../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CommanDialog from "../CommonCompo/CommanDialog/CommanDialog";

export const InventoryAssetForm = ({ onClose, editData, dropdownOpts, columnConfig, selectedAssetType, handleAssetDetails }) => {

    const { fieldValues, handleReset, handleSave, loader, validateUniqueId, error, formFields, handleChange, draft, setDraft } = useInventoryAssetForm({ onClose, editData, dropdownOpts, columnConfig, selectedAssetType, handleAssetDetails });

    return (
        <div>
            <div className="d-flex justify-content-between flex-wrap row-gap-3 mb-2">
                {formFields?.map((section) => (
                    !section?.hide && <div className="border rounded bg-white" style={{ width: section?.width ? `${section?.width}%` : "49%" }}>
                        <div className="fw-bold border-bottom px-4 py-2 rounded-top" style={{ color: "#f59e0b" }}>{section?.title}</div>
                        <div className="row px-3 py-1">
                            {section?.component ?
                                section.component
                                : section?.children?.map((item, index) => (
                                    !item?.hide && <div className="d-flex justify-content-between align-items-center" key={index}>
                                        {item?.title && <div className="w40">{item?.title} <span className="text-danger">{item?.required ? "*" : ""}</span></div>}
                                        <div style={{ width: item?.child_width ? `${item?.child_width}%` : "60%" }}>
                                            {renderField(item, index, (e, is_edit) => { handleChange(item, e, is_edit) }, fieldValues, error, {}, null, () => { if (item?.name === "asset_unique_id" || item?.name === "machine_host_name" || item?.name === "finance_unique_id") { validateUniqueId(item?.name) } })}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="d-flex flex-wrap gap-2">
                <div className="d-flex gap-2 justify-content-end w100">
                    <button className="sk-btn-primary" onClick={() => { if (editData?.asset_id) { onClose(); handleReset(); } else { setDraft((prev) => ({ ...prev, confirmation: true })) } }}>
                        {editData?.asset_id ? "Cancel" : <div><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /> Draft</div>}
                    </button>
                    {loader ?
                        <button className="sk-btn-primary bg-black text-white w10">
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                        <button className="sk-btn-primary bg-black text-white w10" onClick={() => handleSave()}>Save Asset</button>
                    }
                </div>
            </div>
            <CommanDialog visible={draft?.confirmation} handleClose={() => setDraft((prev) => ({ ...prev, confirmation: false }))} handleFun={() => handleSave(true)} message="Draft will be lost after logout or in a new tab" />
        </div>
    )
}
